import React from 'react';

import Box from 'components/Box';
import { Card } from 'components/Cms/Amp/CardsBlock';
import { gutterWidth } from 'theme';

type JobCardProps = {
  layout: 'SLIM' | 'REGULAR';
};
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
export const JobCard = ({ layout }: JobCardProps) => (
  <Box
    // @ts-expect-error ts-migrate(2695) FIXME: Left side of comma operator is unused and has no s... Remove this comment to see the full error message
    display={('block', null, 'inline-block')}
    width={[1, null, 1 / 3]}
    verticalAlign="top"
    maxWidth={320}
    px={[0, null, gutterWidth / 2]}
    py={[gutterWidth / 2, null, 0]}
  >
    <Card
      card={{
        image:
          layout === 'SLIM'
            ? undefined
            : {
                filename: '{{logo.filename}}',
                handle: '{{logo.handle}}',
                mimetype: '{{logo.mimetype}}',
                size: parseInt('{{logo.size}}', 10),
                source: '{{logo.source}}',
              },
        headline: '{{name}}',
        text: '{{city}}, {{state}}',
        label: '{{orgName}}',
        urls: {
          en: '{{url.en}}',
          es: '{{url.es}}',
          pt: '{{url.pt}}',
        },
      }}
      imageSize="SMALL"
    />
  </Box>
);
